module.exports = __webpack_public_path__ + "img/layers_clear.c2dd87f0.svg";